import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { PUBLIC_REGISTRATION_ENABLED } from "../../config/features";
import logoJais from "../../assets/logo_jais.png";
import khatJais from "../../assets/khat_jais.png";
import logoIsyaems from "../../assets/isyaems_logo_wide.png";

const PublicHeader = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const close = () => setMenuOpen(false);

    return (
        <header className="pp-header">
            <div className="pp-header-in">
                <div className="pp-brand">
                    <img className="pp-crest" src={logoJais} alt="Jata JAIS" />
                    <img className="pp-khat" src={khatJais} alt="Khat JAIS" />
                    <span className="pp-divider" aria-hidden="true"></span>
                    <img className="pp-isy" src={logoIsyaems} alt="i-SYAEMS" />
                    <div className="pp-brand-txt">
                        <span className="pp-brand-ey">Bahagian Pengurusan Penguatkuasaan</span>
                        <span className="pp-brand-ttl">Portal Pengurusan Penguatkuasaan Syariah JAIS</span>
                    </div>
                </div>

                <button
                    type="button"
                    className="pp-toggle"
                    aria-label={menuOpen ? "Tutup menu" : "Buka menu"}
                    aria-expanded={menuOpen ? "true" : "false"}
                    onClick={() => setMenuOpen((p) => !p)}
                >
                    <i className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"}`}></i>
                </button>

                <div className={`pp-right${menuOpen ? " is-open" : ""}`}>
                    <nav className="pp-nav">
                        <NavLink to="/" end className="pp-link" onClick={close}>Utama</NavLink>
                        <NavLink to="/about-us" className="pp-link" onClick={close}>Mengenai<br />Kami</NavLink>
                        <NavLink to="/semak-status" className="pp-link" onClick={close}>Semak<br />Aduan</NavLink>
                        <NavLink to="/contact-us" className="pp-link" onClick={close}>Hubungi<br />Kami</NavLink>
                    </nav>
                    <div className="pp-actions">
                        <Link to="/sign-in" className="pp-btn pp-btn-solid" onClick={close}>
                            <i className="bi bi-person-fill"></i> Log Masuk
                        </Link>
                        {PUBLIC_REGISTRATION_ENABLED && (
                            <Link to="/register" className="pp-btn pp-btn-out" onClick={close}>
                                <i className="bi bi-person-plus-fill"></i> Daftar
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};

export default PublicHeader;
